import React from 'react';

interface CardSectionHeaderProps {
  title: string;
  subtitle?: string;
  hint?: string;
}

/** Section title (15 px), the one-line question it answers and a hint. */
const CardSectionHeader: React.FC<CardSectionHeaderProps> = ({ title, subtitle, hint }) => (
  <>
    <div className="product-card-section__header">
      <h3>{title}</h3>
      {subtitle && <span className="product-card-section__question">{subtitle}</span>}
    </div>
    {hint && <p className="product-card-section__hint">{hint}</p>}
  </>
);

export default CardSectionHeader;
